import React from 'react'
import values from 'mout/object/values'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText'
import { SubjectDonut } from './'

export default function SubjectDonuts({studentScore, subtests}) {
  const subs = sortByPropText(values(subtests), 'displayName')
  const { scoring } = studentScore
  return (
    <div className="Subjects DonutChart">
      {subs.map(({displayName, setId}) => 
        <SubjectDonut 
          key={`SubjDonut${displayName}`}
          displayName={displayName}
          score={scoring.bySubtest[setId].scale}
        />
      )}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReport/SubjectDonuts.js